import styled, { css } from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled.article`
    margin: ${theme.space[5]}px 0;
`;

export const Title = styled.h2`
    margin-bottom: ${theme.space[1]}px;
    font-family: ${theme.fonts.regular};
    font-size: 2rem;
    letter-spacing: 0.15rem;
    line-height: 2.8rem;
    text-transform: uppercase;
    color: ${theme.colors.midnight};

    @media ${getBreakpoint("up", "xl")} {
        font-size: 2.8rem;
        line-height: 3rem;
    }
`;

export const Description = styled.div`
    font-family: ${theme.fonts.book};
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    line-height: 3rem;
    color: ${theme.colors.midnight};
`;

export const BenefitsContainer = styled.details`
    margin: ${theme.space[3]}px 0 ${theme.space[4]}px 0;
`;

export const BenefitsHeader = styled.summary`
    display: flex;
    align-items: center;
    column-gap: ${theme.space[1]}px;
    font-family: ${theme.fonts.book};
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    line-height: 3rem;
    color: ${theme.colors.midnight};

    /* Hide default marker */
    &::marker,
    &::-webkit-details-marker {
        display: none;
        width: 0;
        height: 0;
        content: "";
    }
`;

export const BenefitsContent = styled.div``;

export const ButtonGroup = styled.div<{ hideOnMobile?: boolean }>`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.space[4]}px;

    &:not(:nth-last-child(1)) {
        margin-bottom: ${theme.space[1]}px;
    }

    & > a {
        flex: 1;
    }

    @media ${getBreakpoint("up", "lg")} {
        flex-direction: row;
        column-gap: ${theme.space[4]}px;

        & > a {
            flex-basis: 50%;
        }
    }

    ${({ hideOnMobile }) =>
        hideOnMobile &&
        css`
            display: none;
            @media ${getBreakpoint("up", "lg")} {
                display: flex;
            }
        `};
`;
